module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Review Your Cart")]), _c('section', {
    staticClass: "basket"
  }, [_c('div', {
    staticClass: "cart"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("Your cart")]), _c('div', {
    staticClass: "cart-table"
  }, [_vm._m(0), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('figure', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])
  }), _vm._m(1), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_vm._v(_vm._s(product.name))])
  }), _vm._m(2), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_vm._v("$ " + _vm._s(product.price))])
  }), _vm._m(3), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })], 2), _vm._m(4)]), _c('div', {
    staticClass: "payment"
  }, [_vm._m(5), _c('div', {
    staticClass: "payment-total"
  }, [_c('h2', [_vm._v("Cart Total")]), _c('div', {
    staticClass: "subtotal-line"
  }, [_c('p', [_vm._v("Subtotal")]), _c('p', [_vm._v("$" + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "total-line"
  }, [_c('p', [_vm._v("Total")]), _c('p', [_vm._v("$" + _vm._s(_vm.cartAmount()))])]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Proceed to Checkout")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("PRODUCT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("NAME")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("PRICE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("REMOVE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-footer"
  }, [_c('input', {
    staticClass: "cart-coupon",
    attrs: {
      "type": "text",
      "placeholder": "Put you code here..."
    }
  }), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Apply")]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Renew Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-payment"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('p', {
    staticClass: "payment-details"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed\ndo eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/paypal.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/visa.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/mastercard.svg")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d9797374"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Cart.vue
// module id = 134
// module chunks = 0